import React, { useEffect, useState } from 'react';
import { SelectArrayInputProps } from 'react-admin';

import { SelectArrayInput } from '@components';
import { dealerHttp } from '@network';
import { Dealer } from '@types';

interface OptionProps {
  id: number;
  name: string;
}

export const CreditDealersFilter = (props: SelectArrayInputProps) => {
  const [options, setOptions] = useState<OptionProps[]>([]);

  useEffect(() => {
    (async () => {
      const items: Dealer[] = props.source === 'buyers'
        ? await dealerHttp.getBuyerList()
        : props.source === 'retailers'
          ? await dealerHttp.getRetailerList()
          : await dealerHttp.getAssociateList();
      setOptions(items.map(i => ({
        id: i.id,
        name: i.name,
      })).sort((a, b) => a.name > b.name ? 1 : -1));
    })();
  }, []);

  return (
    <SelectArrayInput
      {...props}
      choices={options}
      className="MS-field"
      style={{ width: 280 }}
      alwaysOn
    />
  );
};
